<template>
  <Layout>
    <div class="container pt-16 pb-20">
      <h1 v-if="headline" class="text-2xl mb-8 text-blue-500">
        {{ headline }}
      </h1>
      <template v-if="content">
        <div
          class="max-w-3xl text"
          v-html="content"
        />
      </template>
      <div v-else class="max-w-3xl text">
        <slot name="default" />
      </div>
    </div>
    <Cart />
  </Layout>
</template>

<script>
import useMeta from '@/compose/meta';
import Layout from 'Web/Layouts/Default.vue';
import Cart from 'Web/Shared/Cart.vue';
import rescue from '@/helpers/rescue';
import { Inertia } from '@inertiajs/inertia';
import { onMounted, onUnmounted } from 'vue';

export default {
  inheritAttrs: false,
  components: {
    Layout,
    Cart,
  },
  props: {
    headline: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    content: {
      type: String,
      default: null,
    }
  },
  setup(props) {
    const { assign } = useMeta();

    assign({ title: `DAS DA-Onlineshop - ${props.title ?? props.headline}` });

    let links;

    function inertia(event) {
      event.preventDefault();
      Inertia.visit(event.target.href);
    }

    onMounted(() => {
      links = [...document.querySelectorAll('a[data-inertia]')];
      links.forEach(link => link.addEventListener('click', inertia))
    });

    onUnmounted(() => {
      links.forEach(link =>
        rescue(link.removeEventListener('click', inertia))
      );
    });
  }
}
</script>
